export const blobMap = new Map<string, any>();